import createIcon from '../../createIcon';

/**
 * @component @name Landslide
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuOTcgMTQuNzlMMTIuMzkgMTMuNzZMNS41IDE2LjA1TDEuNSAxNC41MVYxNi42MUw1LjUgMTcuOTVMMTQuOTcgMTQuNzlaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTAuMDcgMTIuNDJMNy41IDlIMS41VjEyLjYxTDUuNSAxMy45NUwxMC4wNyAxMi40MloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik01LjUgMjAuMDVMMS41IDE4LjcyVjIzSDIxLjVMMTYuNTMgMTYuMzhMNS41IDIwLjA1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE2LjUgN1YyTDExLjUgMUw4LjUgM1Y3TDExLjUgOUwxNi41IDdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTggOEwxNS41IDEwVjEzTDE4IDE1TDIyLjUgMTNWOUwxOCA4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Landslide = createIcon('Landslide', [
  [
    'path',
    {
      d: 'M14.97 14.79L12.39 13.76L5.5 16.05L1.5 14.51V16.61L5.5 17.95L14.97 14.79Z',
      key: '1okbei',
    },
  ],
  ['path', { d: 'M10.07 12.42L7.5 9H1.5V12.61L5.5 13.95L10.07 12.42Z', key: '6yqou2' }],
  ['path', { d: 'M5.5 20.05L1.5 18.72V23H21.5L16.53 16.38L5.5 20.05Z', key: '1wn7wm' }],
  ['path', { d: 'M16.5 7V2L11.5 1L8.5 3V7L11.5 9L16.5 7Z', key: 'sisg4u' }],
  ['path', { d: 'M18 8L15.5 10V13L18 15L22.5 13V9L18 8Z', key: '17uw23' }],
]);

export default Landslide;
